import React from 'react';
import { Asset } from '../../../types/asset';
import Marquee from 'react-fast-marquee';
import Ticker from 'react-ticker';

interface SectionWithMarqueeProps {
  name: string;
  description?: string;
  marqueeText: string;
  images: Asset[];
}

export const SectionWithMarquee: React.FC<SectionWithMarqueeProps> = ({ name, description, marqueeText, images }) => {

  marqueeText = marqueeText.replaceAll(' / ', '<span class="inline-block px-4">/</span>');

  return (
    <>
      <div className={'pt-20 px-6'}>
        <h2 className={'font-playfair text-4xl text-center'}>{name}</h2>
        {description && <p className={'mx-auto max-w-4xl mt-6 text-md text-center'}>{description}</p>}
      </div>
      <div className={'mt-12 mb-24'}>
          <Marquee gradient={false} speed={60}>
              <div className={'font-playfair text-2xl h-12 leading-10 sm:text-4xl text-center'} style={{ whiteSpace: 'nowrap'}}>
                <span dangerouslySetInnerHTML={{__html: marqueeText + '<span class="inline-block px-4">/</span>'}} />
              </div>
          </Marquee>
      </div>
      <div className={'pb-20 px-6 border-black border-b '}>
        <div className={'grid md:grid-cols-3 gap-2 md:gap-6 max-w-6xl mx-auto'}>
            {images.map((image) => (
              <div
              key={image.url}
              className={'bg-cover bg-center flex items-end px-3 pb-3'}
              style={{ backgroundImage: `linear-gradient(rgba(180, 180, 180, 0) 60%, rgba(60, 60, 60, 0.8)), url(${image.url})`, height: '450px' }}
              >
                  <p className={'text-white'}>{image.name}</p>
                </div>
            ))}
        </div>
      </div>
    </>
  );
};
